import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

import { HorizontalScroll, useScrollEdges } from '../model/use-horizontal-scroll';
import { TableScrollControls } from './table-scroll-controls';

interface FullscreenDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  /** Scroll state of the table inside the dialog — the dialog has no toolbar, its header carries the arrows */
  scroll: HorizontalScroll;
  children: React.ReactNode;
}

export function FullscreenDialog({ open, onOpenChange, title, scroll, children }: FullscreenDialogProps) {
  const { canScrollStart, canScrollEnd } = useScrollEdges(scroll);
  const overflows = canScrollStart || canScrollEnd;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="!h-screen !max-h-screen !w-screen !max-w-[100vw] flex flex-col p-0 gap-0 rounded-none data-[state=open]:!w-screen"
        style={{ maxWidth: '100vw', width: '100vw', height: '100vh' }}>
        {(title || overflows) && (
          // pr-12 keeps the arrows clear of the dialog's absolutely placed close button
          <DialogHeader className="p-6 pb-4 pr-12 border-b shrink-0 flex-row items-center justify-between gap-4">
            {title && <DialogTitle className="text-xl font-semibold">{title}</DialogTitle>}
            {overflows && <TableScrollControls scroll={scroll} className="ml-auto" />}
          </DialogHeader>
        )}
        <div className="flex-1 flex flex-col min-h-0">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
